module.exports = __webpack_public_path__ + "static/media/YouTube_loading_symbol_2_(stable).ec83227e.gif";